import { mainApi } from '../../../../api/mainApi';

import { setRolesList } from './rolesSlice';
import { middlewareApi } from '../../../middleware/middlewareApi';

import { RolesResponse, Role, RolePayload } from '../interfaces/roles.interfaces';
import { AccessState } from '../../../../types';

export const rolesTags = middlewareApi.enhanceEndpoints({
  addTagTypes: ['Roles', 'RolesAvailables', 'RolesTree', 'Role'],
  // endpoints: {
  //   getRoles: {
  //     providesTags: (result: RolesResponse | undefined) =>
  //       result
  //         ? [
  //             ...result.data.map(({ id }) => ({ type: 'Roles', id } as const)),
  //             { type: 'Roles', id: 'LIST' },
  //           ]
  //         : [{ type: 'Roles', id: 'LIST' }],
  //   },

  //   addRole: {
  //     invalidatesTags: [
  //       { type: 'Roles', id: 'LIST' },
  //       { type: 'RolesAvailables', id: 'COMBO_ROLES_LIST' },
  //     ],
  //   },

  //   deleteRole: {
  //     invalidatesTags: [
  //       { type: 'Roles', id: 'LIST' },
  //       { type: 'RolesAvailables', id: 'COMBO_ROLES_LIST' },
  //     ],
  //   },
  //   //
  // },
});
// Define a service using a base URL and expected endpoints
export const rolesApi = rolesTags.injectEndpoints({
  // reducerPath: 'rolesApi',

  // baseQuery: fetchBaseQuery(),

  // tagTypes: ['Roles', 'RolesAvailables', 'RolesTree', 'Role'],

  overrideExisting: false,

  endpoints: (builder) => ({
    /**
     * @GET all roles
     */
    getRoles: builder.query<
      RolesResponse,
      { profileId: number; page: number; perPage: number; search: string }
    >({
      queryFn: async ({ profileId, page, search, perPage }, { dispatch }) => {
        try {
          const { data } = await mainApi.get<RolesResponse>('/roles', {
            params: {
              user_profile_id: profileId,
              page,
              size: perPage,
              type_sort: 'desc',
              search,
            },
          });

          dispatch(setRolesList(data.data));

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: 'Roles', id } as const)),
              { type: 'Roles', id: 'LIST' },
            ]
          : [{ type: 'Roles', id: 'LIST' }],
    }),

    /**
     * @GET all roles Avalibles
     * @param profileId is for user profile id
     * @param profile_id is for profile id
     */
    getAvaliblesRoles: builder.query<Role[], { profileId?: Number; profile_id?: number }>({
      queryFn: async ({ profileId, profile_id }, { dispatch, getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };

          const user_profile_id = currentProfile?.profileId || profileId;

          const { data } = await mainApi.get<Role[]>('/roles', {
            params: {
              user_profile_id,
              data: 'all',
              profile_id,
              sort: 'name',
              type_sort: 'asc',
            },
          });

          dispatch(setRolesList(data));

          return { data: Array.isArray(data) ? data : [] };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: [{ type: 'RolesAvailables', id: 'COMBO_ROLES_LIST' }],
    }),

    /**
     * @GET role by id
     */
    getRole: builder.query<Role, { profileId: number; roleId: number }>({
      queryFn: async ({ profileId, roleId }) => {
        try {
          const { data } = await mainApi.get<Role>(`/roles/${roleId}`, {
            params: {
              user_profile_id: profileId,
            },
          });

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      providesTags: (result, error, { profileId }) => [{ type: 'Role', profileId, id: 'TREE' }],
    }),

    /**
     * @POST create role
     */
    addRole: builder.mutation<Role, { profileId: number; rolePayload: Partial<Role> }>({
      queryFn: async ({ profileId, rolePayload }) => {
        try {
          const { data } = await mainApi.post<Role>('/roles', {
            user_profile_id: profileId,
            ...rolePayload,
          });
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: [
        { type: 'Roles', id: 'LIST' },
        { type: 'RolesAvailables', id: 'COMBO_ROLES_LIST' },
      ],
    }),

    /**
     * @PUT update role
     */
    updateRole: builder.mutation<
      Role,
      { profileId: number; roleId: number; rolePayload: Partial<Role> }
    >({
      queryFn: async ({ profileId, roleId, rolePayload }) => {
        try {
          const { data } = await mainApi.put<Role>(`/roles/${roleId}`, {
            user_profile_id: profileId,
            ...rolePayload,
          });

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: [
        { type: 'Roles', id: 'LIST' },
        { type: 'RolesAvailables', id: 'COMBO_ROLES_LIST' },
      ],
    }),

    /**
     * @PUT update role only invalidate checkbox tree
     */
    updateRoleTree: builder.mutation<
      Role,
      { profileId: number; roleId: number; rolePayload: Partial<RolePayload> }
    >({
      queryFn: async ({ profileId, roleId, rolePayload }) => {
        try {
          const { data } = await mainApi.put<Role>(`/roles/${roleId}`, {
            user_profile_id: profileId,
            ...rolePayload,
          });

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: [
        { type: 'Roles', id: 'LIST' },
        { type: 'Role', id: 'TREE' },
      ],
    }),

    /**
     * @DELETE remove role
     */
    deleteRole: builder.mutation<Role, { profileId: number; roleId: number }>({
      queryFn: async ({ profileId, roleId }) => {
        try {
          const { data } = await mainApi.delete(`roles/${roleId}`, {
            data: {
              user_profile_id: profileId,
            },
          });

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      invalidatesTags: [
        { type: 'Roles', id: 'LIST' },
        { type: 'RolesAvailables', id: 'COMBO_ROLES_LIST' },
      ],
    }),

    //
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetRolesQuery,
  useGetRoleQuery,
  useAddRoleMutation,
  useDeleteRoleMutation,
  useUpdateRoleMutation,
  useGetAvaliblesRolesQuery,
  useUpdateRoleTreeMutation,
} = rolesApi;
